import useMedia from "utils/hooks/useMedia";
import { MOBILE_MENU } from "common/constants";
import React, { useContext } from "react";
import { PageWrapperContext } from "common/Home/PageWrapper.context";
import Flex from "common/Boxes/Flex";

export const CreateTradePageTitle = () => {
  const isMobileCreateTrade = useMedia(
    [`(max-width: ${MOBILE_MENU})`],
    [true],
    false
  );
  const { titleExtraComponent } = useContext(PageWrapperContext);

  return (
    <Flex $justifyContent="flex-start">
      Trading Terminal
      {!isMobileCreateTrade && titleExtraComponent}
    </Flex>
  );
};
